import { combineReducers } from "redux";

import { reducer as postcodeFinder } from "./PostcodeFinder";

export const featuresReducers = combineReducers({
  postcodeFinder,
});
